import {
    AGENT,
    BASE_URL
} from '@/services/api'
import {get, post, postBinary, posttUpload} from "@/utils/request";

/**
 * 列表查询
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function agentList() {
    return get(`${BASE_URL}/ext/wd/ai/helper/agent/list`)
    // return get(`${AGENT}/list`)
}

/**
 * 维盾智库-置顶
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function agentTop(agentId) {
    return post(`${BASE_URL}/ext/wd/ai/helper/agent/top/${agentId}`)
}

/**
 * 维盾智库-取消置顶
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function agentCancelTop(agentId) {
    return post(`${BASE_URL}/ext/wd/ai/helper/agent/cancel/top/${agentId}`)
}

/**
 * 工单类附件下载
 * @returns {Promise<AxiosResponse<T>>}
 */
export function downloadFile(param) {
    return `${BASE_URL}/biz/agent/downloadFile?fileId=${param.uid}&fileName=${param.name}`
}

/**
 * 法律法规-详情
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function lawdDtail(difyId) {
    return get(`${BASE_URL}/ext/ai/law/detail/${difyId}`)
}

/**
 * 法律法规树
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function lawTree(data) {
    return get(`${BASE_URL}/ext/ai/law/lazy/tree`,data)
}

/**
 * 维盾智库-语音转文字
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function audioToText(agentId,parmas,ContentType) {
    return posttUpload(`${BASE_URL}/dify/chat/${agentId}/audio-to-text`,parmas,ContentType)
}

/**
 * 维盾智库-文字转语音
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function textToAudio(agentId,parmas) {
    return postBinary(`${BASE_URL}/dify/chat/${agentId}/text-to-audio`,parmas)
}